import { ROLE_LABELS } from '@convometry/contracts';
import { Badge, Card, EmptyState, Wordmark } from '@convometry/ui';
import { Bot, Building2, ChevronRight } from 'lucide-react';
import { Link, Navigate } from 'react-router';
import { useMe } from '../app/session.js';
import { usePageTitle } from '../app/title.js';

/** `/`: send single-business users straight to their overview; others pick a business. */
export function HomeRedirect() {
  const me = useMe();
  const ms = me.data?.memberships ?? [];
  if (ms.length === 1) return <Navigate to={`/t/${ms[0]!.tenantId}/resumen`} replace />;
  return <Navigate to="/negocios" replace />;
}

export function BusinessPickerPage() {
  usePageTitle('Mis negocios');
  const me = useMe();
  const ms = me.data?.memberships ?? [];
  return (
    <main className="min-h-dvh bg-surface-canvas px-4 py-10">
      <div className="mx-auto grid w-full max-w-[560px] gap-6">
        <Wordmark endorsement />
        <div>
          <h1 className="text-heading font-semibold text-text-primary">Selecciona un negocio</h1>
          <p className="text-body text-text-secondary">Solo ves los negocios en los que tienes una membresía.</p>
        </div>
        {ms.length === 0 ? (
          <Card>
            <EmptyState
              icon={<Building2 aria-hidden />}
              title="Aún no tienes acceso a ningún negocio"
              description="Pide a un propietario que te agregue como usuario. El acceso de soporte de Estateflow requiere una membresía explícita."
            />
          </Card>
        ) : (
          <Card padding="none">
            <ul className="divide-y divide-border-subtle">
              {ms.map((m) => (
                <li key={m.tenantId}>
                  <Link
                    to={`/t/${m.tenantId}/resumen`}
                    className="flex items-center gap-3 px-5 py-4 hover:bg-surface-subtle focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus"
                  >
                    <Building2 aria-hidden className="size-5 shrink-0 text-text-secondary" />
                    <span className="grid min-w-0 flex-1">
                      <span className="truncate font-medium text-text-primary">{m.tenantName}</span>
                      <span className="text-helper text-text-secondary">{ROLE_LABELS[m.role]}</span>
                    </span>
                    {m.isDemo ? <Badge tone="warning">Demo</Badge> : null}
                    <ChevronRight aria-hidden className="size-5 text-text-muted" />
                  </Link>
                </li>
              ))}
            </ul>
          </Card>
        )}
        {me.data?.user.isPlatformAdmin ? (
          <Link
            to="/admin/uso-ia"
            className="inline-flex items-center gap-2 self-start rounded-control text-body font-medium text-brand-hover hover:underline focus-visible:outline-2 focus-visible:outline-focus"
          >
            <Bot aria-hidden className="size-4" /> Uso de IA (interno)
          </Link>
        ) : null}
      </div>
    </main>
  );
}
